import { EEventType } from './../../../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import { IOYProductTypeProps, IOYProductTypeState } from './const';
import OY from '../../../../types/OY';
import { jeact } from '../../../../decorators/jeact';
import { IValueData } from '../../../../types/data';

@jeact({ autoRender: true })
export default class OYProductType extends OY<IOYProductTypeProps, IOYProductTypeState> {
  static displayName = 'OYProductType';

  static defaultProps: Partial<IOYProductTypeProps> = {
    info: []
  }

  public state: IOYProductTypeState = {
    info: []
  };

  $node = {
  }

  getDerivedStateFromProps(nextProps: IOYProductTypeProps, state: IOYProductTypeState) {
    const { value } = nextProps;
    let info: IValueData[] = [];
    if (value.length) {
      const result = nextProps.info.filter(data => {
        if (value.includes(data.value)) {
          return true;
        }
        const infoIncluded = !!(data.info || []).map(item => item.value).filter(va => value.includes(va)).length;
        return infoIncluded
      })

      info = result.reduce((info1, item) => {
        info1.push({ name: item.name, value: item.value });
        return info1.concat(item.info || [])
      }, info)
      // 将已选的放到最前面
      const selected: IValueData[] = [];
      info = info.filter(va => {
        const result1 = nextProps.value.indexOf(va.value) === -1;
        if (!result1) {
          selected.push(va);
        }
        return result1;
      });

      info = selected.concat(info);
    } else {
      info = nextProps.info.map(va => ({ name: va.name, value: va.value }))
    }
    return { ...state, info }
  }

  render() {
    return template({ props: this.props, state: this.state, styles })
  }

  renderRadioCheckbox() {
    const { value } = this.props;
    const { info } = this.state
    this.$el.find('oy-radio-checkbox').OYRadioCheckbox({
      value,
      info,
      onChange: (cvalue: string[]) => {
        this.$emit(EEventType.onChange, cvalue)
      }
    })
  }

  setNode() { }
}



// WEBPACK FOOTER //
// ./src/components/OYFilter/components/OYProductType/index.ts